import React, {useEffect} from "react";
import ScrollAnimation from "react-animate-on-scroll";
import SectionTitle from "../components/sectionTitle/SectionTitle";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../common/breadcrumb/BreadcrumbOne";
import FooterOne from "../common/footer/FooterOne";
import {Link} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Demo from "../innerpages/Demo";

const HappyServices = () => {
  const { t } = useTranslation();
  const isHomePage = window.location.pathname === "/";
  const [crumbVisible, setCrumbVisible] = React.useState(false);
  useEffect(()=>{
      if(window.location.pathname.split('/')[window.location.pathname.split('/').length - 1] === "services-idopontfoglalo-rendszer"){
            setCrumbVisible(true);
      }
  },[])

  const data = [
      {
          title: t('happyServices.erp.title'),
          img: "https://images.happysolutions.hu/foldal-erp-melle%CC%81.jpg",
          description: (
              <>
                  <strong>{t('happyServices.erp.intro')}</strong>
                  <p dangerouslySetInnerHTML={{ __html: t('happyServices.erp.desc') }} />
                  <div style={{ paddingTop: "1rem" }}>
                      <p dangerouslySetInnerHTML={{ __html: t('happyServices.erp.bulletTitle') }} />
                      <ul className="happy-module-list">
                          {t('happyServices.erp.bullets', { returnObjects: true }).map((b, i) => (
                              <li key={i}>{b.desc}</li>
                          ))}
                      </ul>
                      <p style={{ marginTop: '0.5rem' }}>{t('happyServices.erp.note')}</p>
                  </div>
                  <div className="read-more-btn mt--10">
                      <Link className="edu-btn" to="/erp-vallalatiranyitasi-rendszer">
                          {t('happyServices.erp.button')}<i className="icon-arrow-right-line-right"></i>
                      </Link>
                  </div>
              </>
          ),
          reversed: false,
      },
      {
          title: t('happyServices.crm.title'),
          img: "https://images.happysolutions.hu/CRM-ke%CC%81p-fo%CC%8Boldalra-02.jpg",
          description: (
              <>
                  <strong>{t('happyServices.crm.intro')}</strong>
                  <p dangerouslySetInnerHTML={{ __html: t('happyServices.crm.desc') }} />
                  <div style={{ paddingTop: "1rem" }}>
                      <ul className="happy-module-list">
                          {t('happyServices.crm.bullets', { returnObjects: true }).map((b, i) => (
                              <li key={i}>{b.desc}</li>
                          ))}
                      </ul>
                      <p style={{ marginTop: '0.5rem' }}>{t('happyServices.crm.note')}</p>
                  </div>
                  <div className="read-more-btn mt--10">
                      <Link className="edu-btn" to="/crm-rendszer">
                          {t('happyServices.crm.button')}<i className="icon-arrow-right-line-right"></i>
                      </Link>
                  </div>
              </>
          ),
          reversed: true,
      },
      {
          title: t('happyServices.trade.title'),
          img: "https://images.happysolutions.hu/TRADE-ke%CC%81p-fo%CC%8Boldalra.jpg",
          description: (
              <>
                  <strong>{t('happyServices.trade.intro')}</strong>
                  <p dangerouslySetInnerHTML={{ __html: t('happyServices.trade.desc') }} />
                  <div style={{ paddingTop: "1rem" }}>
                      <ul className="happy-module-list">
                          {t('happyServices.trade.bullets', { returnObjects: true }).map((b, i) => (
                              <li key={i}>{b.desc}</li>
                          ))}
                      </ul>
                      <p style={{ marginTop: '0.5rem' }}>{t('happyServices.trade.note')}</p>
                  </div>
                  <div className="read-more-btn mt--10">
                      <Link className="edu-btn" to="/trade-kereskedelmi-rendszer">
                          {t('happyServices.trade.button')}<i className="icon-arrow-right-line-right"></i>
                      </Link>
                  </div>
              </>
          ),
          reversed: true,
      },
      {
          title: t('happyServices.gastro.title'),
          img: "https://images.happysolutions.hu/gastro-melle%CC%81.jpg",
          description: (
              <>
                  <strong>{t('happyServices.gastro.intro')}</strong>
                  <p dangerouslySetInnerHTML={{ __html: t('happyServices.gastro.desc') }} />
                  <ul className="happy-module-list">
                      {t('happyServices.gastro.bullets', { returnObjects: true }).map((b, i) => (
                          <li key={i}>
                              {b.label ? <><strong>{b.label}</strong> {b.desc}</> : <>{b.desc}</>}
                          </li>
                      ))}
                  </ul>
                  <strong>{t('happyServices.gastro.more')}</strong>
                  <div className="read-more-btn mt--10">
                      <Link className="edu-btn" to="/gastro-ettermi-szoftver">
                          {t('happyServices.gastro.button')}<i className="icon-arrow-right-line-right"></i>
                      </Link>
                  </div>
              </>
          ),
          reversed: false,
      },
      {
          title: t('happyServices.services.title'),
          img: "https://images.happysolutions.hu/happy-services-melle%CC%81.jpg",
          description: (
              <>
                  <strong>{t('happyServices.services.intro')}</strong>
                  <p dangerouslySetInnerHTML={{ __html: t('happyServices.services.desc') }} />
                  <div style={{ paddingTop: "1rem" }}>
                      <ul className="happy-module-list">
                          {t('happyServices.services.bullets', { returnObjects: true }).map((b, i) => (
                              <li key={i}>{b.desc}</li>
                          ))}
                      </ul>
                  </div>
                  <p style={{ marginTop: '0.5rem' }}>{t('happyServices.services.note')}</p>
                  <div className="read-more-btn mt--10">
                      <Link className="edu-btn" to="/services-idopontfoglalo-rendszer">
                          {t('happyServices.services.button')}<i className="icon-arrow-right-line-right"></i>
                      </Link>
                  </div>
              </>
          ),
          reversed: false,
      },
  ];
    return (
        <>
            {!isHomePage && <SEO title="Szolgáltatások"/>}
            <Layout>
                {crumbVisible && <BreadcrumbOne
                    style={{textAlign: "center", padding: "35px auto"}}
                    title={t('common.products')}
                />}

                <div
                    className="edu-about-area eduvibe-contact-us about-style-3 bg-image happy-services"
                    style={{padding: "4rem 0"}}
                >
                    <div className="container eduvibe-animated-shape">
            {data.map((row, idx) => {
              const imageLeft = idx % 2 === 0; // first row: image on the left, text on the right
              return (
                <div
                  className="d-flex"
                  id={row.title}
                  style={{
                    flexDirection: imageLeft ? "row-reverse" : "row",
                    alignItems: "center",
                    gap: "6rem",
                    margin: "3rem 0",
                  }}
                >
                  <div className="inner" style={{ width: "100%" }}>
                    <SectionTitle classes="text-start" title={row.title} />
                    <ScrollAnimation
                      animateIn="fadeInUp"
                      animateOut="fadeInOut"
                      animateOnce={true}
                    >
                      <p className="description mt--40">{row.description}</p>
                    </ScrollAnimation>
                  </div>
                  <div className="inner" style={{ maxWidth: "fit-content" }}>
                    <ScrollAnimation
                      animateIn="fadeIn"
                      animateOut="fadeInOut"
                      className="testimonial-left-image"
                      animateOnce={true}
                      style={{ margin: "5rem 0" }}
                    >
                      <div className="thumbnail">
                        <div
                          className="circle-image-wrapper"
                          style={{ width: "52rem" }}
                        >
                          <img
                            style={{
                              width: "50rem",
                              height: "50rem",
                              objectFit: "cover",
                            }}
                            className="radius-round"
                            src={row.img}
                            alt="Futár modul"
                          />
                          <div className="circle-image">
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                      </div>
                    </ScrollAnimation>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Layout>
      {!isHomePage && <FooterOne />}
    </>
  );
};
export default HappyServices;
